import React, { useEffect } from "react";
import { Button, makeStyles } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import { skills } from "./projectdata";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Resume from "../images/Anjan_Poudel.pdf";
const useStyles = makeStyles((theme) => ({
    aboutme_content: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "80px",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
        },
    },
    btn: {
        fontSize: "17px",
        padding: "5px 20px",
        backgroundColor: "#089199",
        color: "white",
        "&:hover": {
            backgroundColor: "teal",
        },
    },
    me: {
        width: "50%",
        lineHeight: "30px",

        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    mydata: {
        display: "flex",
        justifyContent: "center",
        marginTop: "50px",
        flexDirection: "column",
    },
    resume: {
        width: "50%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",

        [theme.breakpoints.down("sm")]: {
            marginTop: "40px",
            width: "100%",
        },
    },
    section: {
        marginLeft: "8%",
        display: "flex",
        padding: "25px 0",
        marginBottom: "50px",
        borderBottom: "1px solid #ddd",
        borderTop: "1px solid #ddd",
        [theme.breakpoints.down("sm")]: {
            marginLeft: "0",
            flexDirection: "column",
        },
    },
    topicWrap: {
        width: "300px",
        fontSize: "20px",
        fontWeight: "500",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    topic: {
        width: "15px",
        borderBottom: "3px solid teal",
    },

    skill: {
        display: "flex",
        flexWrap: "wrap",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            justifyContent: "space-around",
            marginTop: "40px",
        },
    },
    Skillname: {
        fontSize: "17px",
        fontWeight: "500",
        marginBottom: "8px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "15px",
            marginBottom: "5px",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "14px",
            marginBottom: "5px",
        },
    },
    indivisualSkill: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "15px 40px 15px 0px",
        [theme.breakpoints.down("sm")]: {
            margin: "10px 15px",
        },
        [theme.breakpoints.down("xs")]: {
            margin: "8px 12px",
        },
    },
    image: {
        opacity: "0.8",
        [theme.breakpoints.down("sm")]: {
            transform: "scale(0.7)",
        },
        [theme.breakpoints.down("xs")]: {
            transform: "scale(0.6)",
        },
    },
}));
function About_me() {
    const classes = useStyles();

    const { ref, inView } = useInView(); //inview is boolean to say if it is view... ref is to be specified to component that needs to be monitored

    const animation = useAnimation();

    useEffect(() => {
        if (inView) {
            animation.start({
                opacity: 1,
                transition: {
                    duration: 0.7,
                },
            });
        }
        if (!inView) {
            animation.start({
                opacity: 0,
            });
        }
    }, [inView]);
    return (
        <motion.div
            ref={ref}
            animate={animation}
            className={classes.about_me}
            id="about_me"
        >
            <h2>About ME</h2>
            <div className={classes.aboutme_content}>
                <div className={classes.me}>
                    Namaste! Fueled by high energy level and immense enthusiasm,
                    I started my journey diving into front-end development on my
                    own.As I delved deeper into technologies, I found myself
                    exploring the dynamic realm of Web3 and crafting projects
                    within its innovative landscape.
                    <br /> Continuously learning, embracing challenges, and
                    crafting new innovations - it's the essence of my journey as
                    a developer. I am a fast learner, a good team member and an
                    impressive leader whenever I need to take that role. With a
                    natural ability to inspire and entertain, I believe I am a
                    person easy to collaborate with. I am a passionate coder,
                    solving problems using the best standards, practices and
                    tools.
                </div>
                <div className={classes.resume}>
                    <a
                        href={Resume}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                    >
                        {" "}
                        <Button className={classes.btn}>
                            Download Resume{" "}
                            <GetAppIcon style={{ marginLeft: "5px" }} />
                        </Button>
                    </a>
                </div>
            </div>
            <div className={classes.mydata}>
                <div className={classes.section}>
                    <div className={classes.topicWrap}>
                        <div className={classes.topic}>Skills</div>
                    </div>

                    <div className={classes.skill}>
                        {skills.map((a) => {
                            return (
                                <div className={classes.indivisualSkill}>
                                    <div className={classes.Skillname}>{}</div>
                                    <div className={classes.image}>
                                        <img
                                            src={a.imageURL}
                                            height={
                                                a.height ? a.height : "auto"
                                            }
                                            width={a.width ? a.width : "auto"}
                                            alt={a.name.toUpperCase()}
                                            title={a.name.toUpperCase()}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </motion.div>
    );
}

export default About_me;
